export const isDefined = <T>(value: unknown): value is T => {
  return value !== null && value !== undefined;
};
